import React, { useState } from 'react';
import { handleExport } from '../Print/ExportToExcel';

const initialSectionsSS = [
  {
    "ADMISSION ID": "",
    "NAME": "",
    "Pending Fees": "FEES",
    "Pending Discount": "DISCOUNT",
    "Pending Paid": "PAID",
    "Pending Pending": "PENDING",
    "1st Term Fees": "FEES",
    "1st Term Discount": "DISCOUNT",
    "1st Term Paid": "PAID",
    "1st Term Pending": "PENDING"
  },
  {
    "ADMISSION ID": "A100",
    "NAME": "KEERTHI",
    "Pending Fees": "1000",
    "Pending Discount": "100",
    "Pending Paid": "100",
    "Pending Pending": "800",
    "1st Term Fees": "1000",
    "1st Term Discount": "200",
    "1st Term Paid": "200",
    "1st Term Pending": "600"
  },
  {
    "ADMISSION ID": "A101",
    "NAME": "KEERTHI",
    "Pending Fees": "1200",
    "Pending Discount": "150",
    "Pending Paid": "100",
    "Pending Pending": "950",
    "1st Term Fees": "1100",
    "1st Term Discount": "250",
    "1st Term Paid": "200",
    "1st Term Pending": "650"
  }
];


const ExportCollectionReport = ({user}) => {
  const [tableData, setTableData] = useState(initialSectionsSS);

  const exportExcel = () => {
    handleExport(tableData, 'excel', 'StudentFeesReport1');
  };

  const exportPDF = () => {
    handleExport(tableData, 'pdf', 'StudentFeesReport1');
  };

  return (
    <div>
      <h2>Collection Report</h2>
      <button onClick={exportExcel}>Export to Excel</button>
      <button onClick={exportPDF}>Export to PDF</button>
      {/* Optionally render table */}
    </div>
  );
};

export default ExportCollectionReport;
